document.addEventListener('DOMContentLoaded', () => {
    function debounce(func) {
        let timer;
        return function (event) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(func, 250, event);
        };
    }

    /**** Why Rent Video ****/
    const whyRentVideo = document.getElementById('bo-why-rent-video');
    if (whyRentVideo) {
        whyRentVideo.addEventListener('click', function (e) {
            e.preventDefault();
            const videoId = 'QNJz5SSD7mU';
            const iframe = document.createElement('iframe');
            iframe.setAttribute('src', `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`);
            iframe.setAttribute('allow', 'autoplay; encrypted-media');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('title', 'Why You Should Rent Your Band & Orchestra Instruments from Sweetwater');
            const media = whyRentVideo.parentElement;
            media.innerHTML = '';
            media.appendChild(iframe);
        });
    }

    /**** Find Your Instrument Scroll Arrows ****/
    const findInstrumentScroller = document.querySelector('.bo-find-instrument-scroller');
    if (findInstrumentScroller) {
        const findInstrumentGrid = findInstrumentScroller.querySelector('.bo-find-instrument-grid');
        const findInstrumentPrev = findInstrumentScroller.querySelector('.bo-find-instrument-scroll-btn--prev');
        const findInstrumentNext = findInstrumentScroller.querySelector('.bo-find-instrument-scroll-btn--next');

        function updateFindInstrumentButtons() {
            const max = findInstrumentGrid.scrollWidth - findInstrumentGrid.clientWidth;
            findInstrumentPrev.hidden = findInstrumentGrid.scrollLeft <= 1;
            findInstrumentNext.hidden = findInstrumentGrid.scrollLeft >= max - 1 || max <= 0;
        }

        function scrollFindInstrument(direction) {
            const card = findInstrumentGrid.querySelector('.bo-find-instrument-item');
            const gap = parseFloat(getComputedStyle(findInstrumentGrid).gap) || 16;
            const step = ((card && card.offsetWidth) || 200) + gap;
            findInstrumentGrid.scrollBy({
                left: direction === 'next' ? step : -step,
                behavior: 'smooth'
            });
        }

        findInstrumentPrev.addEventListener('click', () => scrollFindInstrument('prev'));
        findInstrumentNext.addEventListener('click', () => scrollFindInstrument('next'));
        findInstrumentGrid.addEventListener('scroll', updateFindInstrumentButtons);

        findInstrumentGrid.addEventListener('focusin', (e) => {
            const card = e.target.closest('.bo-find-instrument-item');
            if (card) {
                card.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
            }
        });

        window.addEventListener('resize', debounce(updateFindInstrumentButtons));
        updateFindInstrumentButtons();
    }

    /**** Get More With Sweetwater Tabs ****/
    const getMore = document.querySelector('.bo-get-more');
    if (getMore) {
        const track = getMore.querySelector('.bo-get-more-track');
        const tabs = Array.from(track.querySelectorAll('.bo-get-more-quality'));
        const getMorePrev = getMore.querySelector('.bo-get-more-scroll-btn--prev');
        const getMoreNext = getMore.querySelector('.bo-get-more-scroll-btn--next');
        const panelWrap = getMore.querySelector('.bo-get-more-panel-wrap');
        const caret = getMore.querySelector('.bo-get-more-caret');
        const panel = getMore.querySelector('.bo-get-more-panel');
        const panelIcon = getMore.querySelector('.bo-get-more-panel-icon-img');
        const panelTitle = getMore.querySelector('.bo-get-more-panel-title');
        const panelCopy = getMore.querySelector('.bo-get-more-panel-copy');

        function positionCaret(tab) {
            const wrapRect = panelWrap.getBoundingClientRect();
            const tabRect = tab.getBoundingClientRect();
            const min = 24;
            const max = wrapRect.width - 24;
            let x = tabRect.left + tabRect.width / 2 - wrapRect.left;
            x = Math.max(min, Math.min(max, x));
            caret.style.left = x + 'px';
        }

        function repositionActiveCaret() {
            const active = track.querySelector('.bo-get-more-quality.is-active') || tabs[0];
            if (active) positionCaret(active);
        }

        function swapPanelContent(tab) {
            panelIcon.src = tab.dataset.iconSrc;
            panelTitle.textContent = tab.dataset.title;
            panelCopy.textContent = tab.dataset.copy;
        }

        let swapTimer = null;
        function activateTab(tab) {
            tabs.forEach((t) => {
                const isActive = t === tab;
                t.classList.toggle('is-active', isActive);
                t.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });
            panel.setAttribute('aria-labelledby', tab.id);
            positionCaret(tab);

            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                swapPanelContent(tab);
                return;
            }
            clearTimeout(swapTimer);
            panel.classList.add('is-swapping');
            swapTimer = setTimeout(() => {
                swapPanelContent(tab);
                panel.classList.remove('is-swapping');
            }, 200);
        }

        tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => activateTab(tab));
            tab.addEventListener('keydown', (e) => {
                let target = null;
                if (e.key === 'ArrowRight') target = tabs[(i + 1) % tabs.length];
                else if (e.key === 'ArrowLeft') target = tabs[(i - 1 + tabs.length) % tabs.length];
                if (!target) return;
                e.preventDefault();
                activateTab(target);
                target.focus({ preventScroll: true });
            });
        });

        track.addEventListener('focusin', (e) => {
            const focusedTab = e.target.closest('.bo-get-more-quality');
            if (focusedTab) {
                focusedTab.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
            }
        });

        function updateGetMoreButtons() {
            if (!getMorePrev || !getMoreNext) return;
            const max = track.scrollWidth - track.clientWidth;
            getMorePrev.hidden = track.scrollLeft <= 1;
            getMoreNext.hidden = track.scrollLeft >= max - 1 || max <= 0;
        }

        function scrollGetMore(direction) {
            const tab = tabs[0];
            const gap = parseFloat(getComputedStyle(track).gap) || 16;
            const step = ((tab && tab.offsetWidth) || 140) + gap;
            track.scrollBy({
                left: direction === 'next' ? step : -step,
                behavior: 'smooth'
            });
        }

        if (getMorePrev) getMorePrev.addEventListener('click', () => scrollGetMore('prev'));
        if (getMoreNext) getMoreNext.addEventListener('click', () => scrollGetMore('next'));
        track.addEventListener('scroll', () => {
            updateGetMoreButtons();
            repositionActiveCaret();
        });
        window.addEventListener('resize', debounce(() => {
            updateGetMoreButtons();
            repositionActiveCaret();
        }));

        updateGetMoreButtons();
        repositionActiveCaret();
    }

    /**** FAQ Accordion ****/
    const faqRows = document.querySelectorAll('.bo-faq-row');
    const faqRowHeaders = document.querySelectorAll('.bo-faq-row-header');
    let pendingExpand = null;
    let faqIdCounter = 0;

    function initFaqRowAria(row) {
        const button = row.querySelector('.bo-faq-toggle');
        const question = row.querySelector('.bo-faq-question');
        const answer = row.querySelector('.bo-faq-answer');
        if (!button || !answer) return;

        button.type = 'button';

        faqIdCounter += 1;
        if (answer.id === '') answer.id = `bo-faq-answer-${faqIdCounter}`;
        button.setAttribute('aria-controls', answer.id);

        if (question) {
            if (question.id === '') question.id = `bo-faq-question-${faqIdCounter}`;
            button.removeAttribute('aria-label');
            button.setAttribute('aria-labelledby', question.id);
        }

        updateFaqRowAria(row);
    }

    function updateFaqRowAria(row) {
        const button = row.querySelector('.bo-faq-toggle');
        if (button) {
            button.setAttribute('aria-expanded', row.classList.contains('expanded') ? 'true' : 'false');
        }
    }

    function collapseFaqRow(row) {
        const header = row.querySelector('.bo-faq-row-header');
        row.style.maxHeight = header.offsetHeight + 'px';
    }

    function expandFaqRow(row) {
        const answer = row.querySelector('.bo-faq-answer');
        row.style.maxHeight = row.scrollHeight + answer.scrollHeight + 'px';
    }

    function refreshFaqRow(row) {
        if (row.classList.contains('expanded')) {
            expandFaqRow(row);
        } else {
            collapseFaqRow(row);
        }
        updateFaqRowAria(row);
    }

    function cancelPendingExpand() {
        if (!pendingExpand) return;
        pendingExpand.target.removeEventListener('transitionend', pendingExpand.listener);
        clearTimeout(pendingExpand.timeout);
        pendingExpand = null;
    }

    faqRows.forEach((row) => {
        initFaqRowAria(row);
        refreshFaqRow(row);
    });

    faqRowHeaders.forEach((header) => {
        header.addEventListener('click', (e) => {
            e.preventDefault();
            cancelPendingExpand();

            const row = header.closest('.bo-faq-row');
            const currentlyExpanded = document.querySelector('.bo-faq-row.expanded');

            if (currentlyExpanded && currentlyExpanded !== row) {
                currentlyExpanded.classList.remove('expanded');
                collapseFaqRow(currentlyExpanded);
                updateFaqRowAria(currentlyExpanded);

                const expandNext = () => {
                    pendingExpand = null;
                    row.classList.add('expanded');
                    expandFaqRow(row);
                    updateFaqRowAria(row);
                };

                const listener = (ev) => {
                    if (ev.propertyName !== 'max-height') return;
                    currentlyExpanded.removeEventListener('transitionend', listener);
                    clearTimeout(timeout);
                    expandNext();
                };

                const timeout = setTimeout(() => {
                    currentlyExpanded.removeEventListener('transitionend', listener);
                    expandNext();
                }, 450);

                currentlyExpanded.addEventListener('transitionend', listener);
                pendingExpand = { target: currentlyExpanded, listener, timeout };
            } else {
                row.classList.toggle('expanded');
                refreshFaqRow(row);
            }
        });
    });

    window.addEventListener('resize', debounce(() => {
        faqRows.forEach(refreshFaqRow);
    }));

});
